import { useMemo } from 'react';
import { unreachableFallback } from '../utils/typeUtils';
import { useGetHasScope } from './useGetHasScope';
const getReadWriteScopeName = (approvalType, action) => {
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      return `email-approval-${action}`;
    case 'BLOG_POST':
      return `blog-approval-${action}`;
    case 'LANDING_PAGE':
      return `landingpages-approval-${action}`;
    case 'SITE_PAGE':
      return `pages-approval-${action}`;
    case 'DEAL':
      return `deal-approval-${action}`;
    case 'KNOWLEDGE_ARTICLE':
      return `knowledge-article-approval-${action}`;
    case 'QUOTE':
      return `quote-approval-${action}`;
    case 'SOCIAL_BROADCAST':
      return `social-broadcast-approval-${action}`;
    case 'CONNECTED_APP':
      return `app-governance-approval-${action}`;
    case undefined:
      return undefined;
    default:
      return unreachableFallback(approvalType, undefined);
  }
};

// Approve scopes follow a different naming convention than read/write scopes.
// Read/write use `{type}-approval-{action}`, but approve scopes use `{domain-noun}-approve`.
// These names are defined in the backend ApprovalTypeToApproveScopeProvider.
const getApproveScopeName = approvalType => {
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      return 'marketing-emails-approve';
    case 'BLOG_POST':
      return 'blog-posts-approve';
    case 'LANDING_PAGE':
      return 'landing-pages-approve';
    case 'SITE_PAGE':
      return 'website-pages-approve';
    case 'DEAL':
      return 'deals-approve';
    case 'KNOWLEDGE_ARTICLE':
      return 'knowledge-articles-approve';
    case 'QUOTE':
      return 'quotes-approve';
    case 'SOCIAL_BROADCAST':
      return 'social-broadcast-approve';
    case 'CONNECTED_APP':
      return 'app-governance-approve';
    case undefined:
      return undefined;
    default:
      return unreachableFallback(approvalType, undefined);
  }
};
export const useHasApprovalScope = (approvalType, action) => {
  const hasScope = useGetHasScope();
  const scopeName = action === 'approve' ? getApproveScopeName(approvalType) : getReadWriteScopeName(approvalType, action);
  return useMemo(() => scopeName ? hasScope(scopeName) : false, [hasScope, scopeName]);
};